import type { PromoTemplateCannedCollectionFragment } from 'bundles/front-page/__generated__/contentfulTypes';

const normalizeBucketsModuleContent = (content: PromoTemplateCannedCollectionFragment) => {
  return content.cardsCollection?.items
    ?.map((item) => {
      if (!item || !item.headline || !item.target) return null;
      return {
        title: item?.headline,
        linkTo: item?.target,
        image: item?.cardBackgroundImage?.url,
      };
    })
    .filter(Boolean);
};

export default normalizeBucketsModuleContent;
